module.exports = __webpack_public_path__ + "img/bc.1f693db5.png";